import { FadeUp, Overline, Stagger, StaggerItem } from "@/components/site/Reveal";
import { UPCOMING_GUESTS } from "@/data/content";

/**
 * COMING TO FORE — showcase for confirmed upcoming guests.
 * INTENTIONALLY HIDDEN: renders nothing until UPCOMING_GUESTS in data/content.js
 * contains real, confirmed, Fore-approved guests (name, descriptor, approved photo).
 * Do not populate with prospective/contacted guests or AI-generated imagery.
 */
const ComingToFore = ({ guests = UPCOMING_GUESTS }) => {
  if (!guests || guests.length === 0) return null;

  return (
    <section className="mt-20" data-testid="coming-to-fore">
      <FadeUp>
        <Overline>Coming To Fore</Overline>
        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter sm:text-4xl lg:text-5xl" data-testid="coming-to-fore-heading">
          Teeing it up<br />with us <span className="text-brand-accent">soon.</span>
        </h2>
      </FadeUp>
      <Stagger className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {guests.map((g) => (
          <StaggerItem key={g.name}>
            <article
              className="group overflow-hidden border border-white/10 bg-ink-2 transition-colors duration-500 hover:border-brand"
              data-testid={`coming-guest-${g.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={g.photo}
                  alt={g.name}
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                />
                <span className="absolute left-4 top-4 bg-brand-accent px-2.5 py-1 font-mono text-[9px] font-medium uppercase tracking-[0.2em] text-ink">
                  Coming Soon
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-white">{g.name}</h3>
                <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-muted">{g.descriptor}</p>
              </div>
            </article>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
};

export default ComingToFore;
